import React,{ Component } from "react";
import {Row, Alert, Col, Spinner, Table, Button, Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import { getLogs, gethosts,setLogsPageInfo} from "../../../actions/actionReporting"
import moment from "moment";
import Proptypes from "prop-types";
import Select from "react-select";
import matchSorter, {rankings} from 'match-sorter'
import LoadingSpinner from "../../../components/LoadingSpinner";
import DateTimePicker from 'react-datetime-picker';
import LogTable from '../../../components/LogTable'

class Logging extends Component{
    constructor(props) {
        super(props);
        this.initialSortHeadings =  {
            ingest_date: false,
            application : false,
            levelname : false,
            host : false,
            message : false,
            kasm_user_name : false,
            allow :false,
            category : false,
            site : false,
          },
        this.state = {
            host: "all",
            application: "all",
            levelname: "INFO",
            limit: 100,
            delta: 60,
            process:'all',
            search: '',
            searchUser: '',
            site: '',
            category: '',
            allowed: 'all',
            moreOptions: false,
            fromReport: false,
            endDate: new Date(),
            startDate: new Date(Date.now() - 60000 * 60),
            optionsMode: "application",
            sortHeading: this.initialSortHeadings,
            activeHeading : '',
            pageSize : this.props.pages.pageSize || 100, 
            pageNo : this.props.pages.pageNo ||  0,
        };
        this.updateAppOption = this.updateAppOption.bind(this);
        this.updateHostOption = this.updateHostOption.bind(this);
        this.updateLevelOption = this.updateLevelOption.bind(this);
        this.updateLimitOption = this.updateLimitOption.bind(this);
        this.updateProcessOption = this.updateProcessOption.bind(this);
        this.updateDelta = this.updateDelta.bind(this);
        this.updateLogs = this.updateLogs.bind(this);
        this.updateSearch = this.updateSearch.bind(this);
        this.updateSearchUser = this.updateSearchUser.bind(this);
        this.updateCategory = this.updateCategory.bind(this);
        this.updateSite = this.updateSite.bind(this);
        this.updateAllowedOption = this.updateAllowedOption.bind(this);
        this.showMore = this.showMore.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeEnd = this.onChangeEnd.bind(this);
        this.sortChange = this.sortChange.bind(this);
        this.setPageSize = this.setPageSize.bind(this);
        this.setPageNo = this.setPageNo.bind(this);
    }

    onChange(date) {
        this.setState({startDate: date});
    }

    onChangeEnd(enddate) {
        this.setState({endDate: enddate});
    }

    showMore() {
        this.setState({moreOptions: !this.state.moreOptions});
    }

    UNSAFE_componentWillMount() {
        const {state} = this.props.location;

        if (state) {
            if (state.level) {
                this.setState({levelname: state.level});
            }
            if (state.search) {
                this.setState({search: state.search});
            }
            if (state.username) {
                this.setState({searchUser: state.username});
            }
            if (state.site) {
                this.setState({site: state.site});
            }
            if (state.optionsMode) {
                this.setState({optionsMode: state.optionsMode});
            }
            if (state.start_date && state.end_date) {
                this.setState({
                    startDate: state.start_date,
                    endDate: state.end_date,
                    moreOptions: true
                });
            } else {
                if (state.delta) {
                    this.setState({delta: state.delta})
                }
            }
        }
    }

    componentDidMount(){
        this.props.gethosts();
        this.updateLogs(this.state.optionsMode)
    }


    updateLogs(optionsMode){
        const {startDate, endDate} = this.state;

        let filters = {};
        filters.filters = {};
        filters.exclude_filters = {};
        if (this.state.application !== 'all') {
            filters.filters.application = this.state.application;
        }
        if (this.state.host !== 'all') {
            filters.filters.host = this.state.host;
        }
        if (this.state.process !== 'all') {
            filters.filters.process = this.state.process;
        }
        if (this.state.search !== '') {
            filters.filters.search = this.state.search;
        }
        if (this.state.searchUser !== '') {
            filters.filters.searchUser = this.state.searchUser;
        }
        if (optionsMode === "filter" ||  this.state.optionsMode === "filter")
        {
            filters.filters.metricName = "url_access"
        }
        else{
            filters.exclude_filters.metricName = "url_access"
        }
        if (this.state.site !== '') {
            filters.filters.site = this.state.site;
        }
        if (this.state.category !== '') {
            filters.filters.category = this.state.category;
        }
        if (this.state.allowed !== 'all') {
            filters.filters.allowed = this.state.allowed;
        }

        filters.filters.levelname = this.state.levelname;
        filters.limit = this.state.limit;
        filters.delta = this.state.delta;
        if (this.state.moreOptions || this.state.fromReport) {
            let start_date = moment(startDate).utc().format("YYYYMMDD HH:mm");
            let end_date = moment(endDate).utc().format("YYYYMMDD HH:mm");
            filters.start_date = start_date;
            filters.end_date= end_date;
            filters.delta = null;
        }
        this.props.getLogs(filters);
    }

    updateProcessOption(res){
        this.setState({process: res.value});
    }

    updateAppOption(res){
        this.setState({application: res.value});
    }

    updateHostOption(res){
        this.setState({host: res.value});
    }

    updateLevelOption(res){
        this.setState({levelname: res.value});
    }

    updateLimitOption(res){
        this.setState({limit: res.value});
    }

    updateDelta(e) {
        this.setState({delta: parseInt(e.target.value)});
    }

    updateSearch(e) {
        this.setState({search: e.target.value});
    }

    updateSearchUser(e) {
        this.setState({searchUser: e.target.value});
    }

    updateCategory(e) {
        this.setState({category: e.target.value});
    }

    updateSite(e) {
        this.setState({site: e.target.value});
    }

    updateAllowedOption(res){
        this.setState({allowed: res.value});
    }

    sortChange(columns){
        let heading = columns[0].id
        this.setState({
            activeHeading : heading
        })
        if(!columns[0].desc){
            const obj = {...this.initialSortHeadings,
            [heading]:true,
            };
           this.setState({
               sortHeading : obj 
           })
        }else{
            const obj = {...this.initialSortHeadings,
            [heading]:false,
            };
               this.setState({
                   sortHeading :obj 
               })
        }  
    }

    setPageSize(value){
        this.setState({
            pageSize : value,
        })
      this.props.setPageInfo({pageSize : value,pageNo : this.state.pageNo})
    }

    setPageNo(page){
        this.setState({
            pageNo : page
        })
         this.props.setPageInfo({pageSize : this.state.pageSize , pageNo : page })  
    }

    render(){
        if (this.props.getLogLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const {logs, hosts} = this.props;
        const loading = false;
        const {optionsMode} = this.state;

        let applicationModeStyle = "btn btn-outline-primary btn-block ";
        let filterModeStyle =  "btn btn-outline-primary btn-block";

        if (optionsMode === "filter"){
            filterModeStyle += " active ";
        }
        else{
            applicationModeStyle += " active ";
        }

        const appOptions = [
            {value:'kasm_api', label:'Kasm API'},
            {value:'kasm_agent', label:'Kasm Agent'},
            {value:'kasm_manager', label:'Kasm Manager'},
            {value:'kasm_share', label:'Kasm Share'},
            {value:'kasm_ui', label:'Kasm UI'},
            {value:'all', label:'All'}
        ];
        const levelOptions = [
            {value:'DEBUG', label:'Debug'},
            {value:'INFO', label:'Info'},
            {value:'WARNING', label:'Warning'},
            {value:'ERROR', label:'Error'},
            {value:'CRITICAL', label:'Critical'},
        ];
        const limitOptions = [
            {value:50, label:'50'},
            {value:100, label:'100'},
            {value:250, label:'250'},
            {value:500, label:'500'},
            {value:1000, label:'1000'},
        ];
        const processOptions = [
            {value:'all', label:'All'},
            {value:'admin_api_server', label:'Admin API Server'},
            {value:'cherrypy', label:'Cherrypy'},
            {value:'client_api_server', label:'Client API Server'},
            {value:'__main__.handler', label:'Handler'},
            {value:'manager_api_server', label:'Manager API Server'},
            {value:'public_api_server', label:'Public API Server'},
            {value:'subscription_api_server', label:'Subscription API Server'}
        ];
        const allowedOptions = [
            {value:'all', label:'All'},
            {value:'true', label:'True'},
            {value:'false', label:'False'},
        ];
        let hostOptions = [];
        if (hosts) {
            for (let host in hosts.data) {
                hostOptions.push({value: hosts.data[host].host, label: hosts.data[host].host});
            }
            hostOptions.push({value: 'all', label: 'All'});
        }

        const applicationColumns = [ {
            // Header: "Timestamp",
            Header :
            <div className ={`table-head-outer ${this.state.activeHeading === "ingest_date" ? 'blue-txt' : ''}`}>
             <p className={`table-head`}> Timestamp
            </p>
            <i className={this.state.sortHeading.ingest_date ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
            </div>,
            accessor: "ingest_date",
            width: 160,
            Cell: (props) => {
                return props.value ?
                    <div>
                        {moment.utc(props.value, 'YYYYMMDD HH:mm').local().format('YYYY-MM-DD HH:mm')}
                    </div> :
                    <div>NA</div>;
                }
            },
            {
                // Header: "Application",
                Header :
                <div className ={`table-head-outer ${this.state.activeHeading === "application" ? 'blue-txt' : ''}`}>
                 <p className={`table-head`}> Application
                </p>
                <i className={this.state.sortHeading.application ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
                </div>,
                accessor: "application",
                width: 155,
                Cell: (props) => {
                    return props.value ? <div>{props.value}</div> : <div>NA</div>;
                }
            },
            {
                // Header: "Level",
                Header :
                <div className ={`table-head-outer ${this.state.activeHeading === "levelname" ? 'blue-txt' : ''}`}>
                 <p className={`table-head`}> Level
                </p>
                <i className={this.state.sortHeading.levelname ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
                </div>,
                accessor: "levelname",
                width: 120,
                Cell: (props) => {
                    return props.value ? <div>{props.value}</div> : <div>NA</div>;
                }
            },
            {
                // Header: "Host",
                Header :
                <div className ={`table-head-outer ${this.state.activeHeading === "host" ? 'blue-txt' : ''}`}>
                 <p className={`table-head`}> Host
                </p>
                <i className={this.state.sortHeading.host ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
                </div>,
                accessor: "host",
                width: 150,
                Cell: (props) => {
                    return props.value ? <div>{props.value}</div> : <div>NA</div>;
                }
            },
            {
                // Header: "Message",
                Header :
                <div className ={`table-head-outer ${this.state.activeHeading === "message" ? 'blue-txt' : ''}`}>
                 <p className={`table-head`}> Message
                </p>
                <i className={this.state.sortHeading.message ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
                </div>,
                accessor: "message",
            }
        ];

        const filterColumns = [ 
            {
            // Header: "Timestamp",
            Header :
            <div className ={`table-head-outer ${this.state.activeHeading === "ingest_date" ? 'blue-txt' : ''}`}>
             <p className={`table-head`}> Timestamp
            </p>
            <i className={this.state.sortHeading.ingest_date ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
            </div>,
            accessor: "ingest_date",
            width: 160,
            Cell: (props) => {
                return props.value ?
                    <div>
                        {moment.utc(props.value, 'YYYYMMDD HH:mm').local().format('YYYY-MM-DD HH:mm')}
                    </div> :
                    <div>NA</div>;
                }
            },
            {
                // Header: "User",
                Header :
                <div className ={`table-head-outer ${this.state.activeHeading === "kasm_user_name" ? 'blue-txt' : ''}`}>
                 <p className={`table-head`}> User
                </p>
                <i className={this.state.sortHeading.kasm_user_name ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
                </div>,
                accessor: "kasm_user_name",
                width: 200,
                Cell: (props) => {
                    return props.value ? <div>{props.value}</div> : <div>NA</div>;
                }
            },
            {
                // Header: "Allowed",
                Header :
                <div className ={`table-head-outer ${this.state.activeHeading === "allow" ? 'blue-txt' : ''}`}>
                 <p className={`table-head`}> Allowed
                </p>
                <i className={this.state.sortHeading.allow ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
                </div>,
                accessor: "allow",
                width: 130,
                Cell: (props) => {
                    return props.value ? <div>{props.value}</div> : <div>NA</div>;
                }
            },
            {
                // Header: "Category",
                Header :
                <div className ={`table-head-outer ${this.state.activeHeading === "category" ? 'blue-txt' : ''}`}>
                 <p className={`table-head`}> Category
                </p>
                <i className={this.state.sortHeading.category ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
                </div>,
                accessor: "category",
                width: 230,
                Cell: (props) => {
                    return props.value ? <div>{props.value}</div> : <div>NA</div>;
                }
            },
            {
                // Header: "Site",
                Header :
                <div className ={`table-head-outer ${this.state.activeHeading === "site" ? 'blue-txt' : ''}`}>
                 <p className={`table-head`}> Site
                </p>
                <i className={this.state.sortHeading.site ? "fa fa-caret-up" : "fa fa-caret-down"} aria-hidden="true"></i>
                </div>,
                accessor: "site",
                Cell: (props) => {
                    return props.value ? <div>{props.value}</div> : <div>NA</div>;
                }
            },

        ];


        const columns = optionsMode === "filter" ? filterColumns : applicationColumns;

        return(
            <div className={"pt-2"}>
               <Row>
                   <Col xl={{ size: 3}}>
                       <Card className = "user-form-container">
                           <CardHeader>
                               <strong>Options</strong>
                           </CardHeader>
                           <CardBody>
                               <Row>
                                   <Col>
                                       <Button outline color="primary" className={applicationModeStyle}  onClick={() =>{
                                           this.setState(
                                               {
                                                   optionsMode: "application",
                                                   application: "all",
                                                   host: "all",
                                                   process: "all",
                                                   search: "",
                                                   searchUser: "",
                                                   levelname: "INFO",
                                                   category: '',
                                                   site: '',
                                                   allowed: 'all',
                                               }, ()=> {
                                                   this.updateLogs("application");
                                               });
                                       }}>
                                           Application</Button>
                                   </Col>
                                   <Col>
                                       <Button outline color="primary" className={filterModeStyle} onClick={() =>{
                                           this.setState(
                                               {
                                                   optionsMode: "filter",
                                                   application: "all",
                                                   host: "all",
                                                   process: "all",
                                                   search: "",
                                                   searchUser: "",
                                                   levelname: "DEBUG",
                                                   category: '',
                                                   site: '',
                                                   allowed: 'all',
                                               }, ()=> {
                                                   this.updateLogs("application");
                                               });
                                           this.updateLogs("filter");
                                       }}>Web Filter</Button>
                                   </Col>
                               </Row>
                               {optionsMode != "filter"?
                                   <React.Fragment>
                                       <small className="text-muted">Level</small><br />
                                       <Select
                                           clearable={false}
                                           autoFocus
                                           value={this.state.levelname}
                                           options={levelOptions}
                                           onChange={this.updateLevelOption}
                                       />
                                   </React.Fragment>
                                : ""}
                               <small className="text-muted">Limit</small><br />
                               <Select
                                   clearable={false}
                                   autoFocus
                                   value={this.state.limit}
                                   options={limitOptions}
                                   onChange={this.updateLimitOption}
                               />
                               {!this.state.moreOptions ?
                                   <React.Fragment>
                                   <small className="text-muted">Time (in minutes)</small><br />
                                   <input  className={"log-search"}
                                           value={this.state.delta}
                                           onChange={this.updateDelta}
                                           type={"number"}
                                   /><br />
                                   </React.Fragment>: ''}
                               {this.state.moreOptions ?
                                   <React.Fragment>
                                       <hr />
                                       <small className="text-muted">Start Date</small><br />
                                       <DateTimePicker
                                           clearIcon={null}
                                           required={true}
                                           onChange={this.onChange}
                                           value={this.state.startDate}
                                       /><br/>
                                       <small className="text-muted">End Date</small><br />
                                       <DateTimePicker
                                       clearIcon={null}
                                       required={true}
                                       onChange={this.onChangeEnd}
                                       value={this.state.endDate}
                                       />

                                       <Button className = "ml-2" color = "primary" onClick={() =>{
                                           this.setState({
                                               endDate: new Date(),
                                               startDate: new Date(Date.now() - 60000 * 60)
                                           });
                                        }
                                       }>Reset</Button>

                                       {optionsMode != "filter"?
                                           <React.Fragment>
                                               <hr />
                                               <small className="text-muted">Application</small><br />
                                               < Select
                                               clearable = {false}
                                               autoFocus
                                               value={this.state.application}
                                               options={appOptions}
                                               onChange={this.updateAppOption}
                                               />

                                               <small className="text-muted">Process</small><br />
                                               <Select
                                                   clearable={false}
                                                   autoFocus
                                                   value={this.state.process}
                                                   options={processOptions}
                                                   onChange={this.updateProcessOption}
                                               />

                                               <small className="text-muted">Host</small><br />
                                               <Select
                                               clearable={false}
                                               autoFocus
                                               value={this.state.host}
                                               options={hostOptions}
                                               onChange={this.updateHostOption}
                                               />
                                           </React.Fragment>

                                           : ''}

                                       <hr />

                                       {optionsMode == "filter" ?
                                           <React.Fragment>
                                               <small className="text-muted">Search Site</small>
                                               <br />
                                               <input className={"log-search"}
                                                      value={this.state.site}
                                                      onChange={this.updateSite}
                                                      type={"text"}
                                               /><br />
                                               <small className="text-muted">Search Category</small>
                                               <br />
                                               <input className={"log-search"}
                                                      value={this.state.category}
                                                      onChange={this.updateCategory}
                                                      type={"text"}
                                               /><br />
                                               <small className="text-muted">Search Allowed</small>
                                               <br />
                                               <Select
                                                   clearable={false}
                                                   autoFocus
                                                   value={this.state.allowed}
                                                   options={allowedOptions}
                                                   onChange={this.updateAllowedOption}
                                               />
                                               <br />
                                           </React.Fragment>
                                           :
                                           <React.Fragment>
                                               <small className="text-muted">Search Message</small>
                                               <br />
                                               <input className={"log-search"}
                                                      value={this.state.search}
                                                      onChange={this.updateSearch}
                                                      type={"text"}
                                               /><br />
                                           </React.Fragment>
                                       }
                                       <small className="text-muted">Search User</small><br />
                                       <input  className={"log-search"}
                                       value={this.state.searchUser}
                                       onChange={this.updateSearchUser}
                                       type={"text"}
                                       />
                                       <button className="link" onClick={this.showMore}>
                                           <small> Less Filters...</small>
                                       </button>
                                   </React.Fragment>
                               : <button className="link" onClick={this.showMore}>
                                       <small> More Filters...</small>
                                 </button>}
                           </CardBody>
                           <CardFooter>
                               <Button 
                               className="submit-button"
                               color="primary" onClick={this.updateLogs}>Update</Button>
                           </CardFooter>
                       </Card>
                   </Col>
                   <Col xl={{ size: 9}}>
                       <Card className = "user-form-container">
                           <CardBody className={"logging"}>
                                <LogTable
                                    columns={columns}
                                    logs={logs}
                                    loading={loading}
                                    sortChange={this.sortChange}
                                    setPageSize={this.setPageSize}
                                    setPageNo={this.setPageNo}
                                    pageSize={this.state.pageSize}
                                    pageNo={this.state.pageNo}
                                />
                           </CardBody>
                       </Card>
                   </Col>
               </Row>
            </div>
        );
    }
}

Logging.propTypes = {
    logs: Proptypes.object
};

let LoggingWithRouter = withRouter(Logging);


export default connect(state =>
        ({
            logs: state.reporting.logs,
            hosts: state.reporting.hosts,
            getLogLoading: state.reporting.getLogLoading,
            pages : {pageSize : state.reporting.pageSize, pageNo : state.reporting.pageNo},
        }),
    dispatch =>
        ({
            getLogs: (data) => dispatch(getLogs(data)),
            gethosts: (data) => dispatch(gethosts(data)),
            setPageInfo : (data)=> dispatch(setLogsPageInfo(data)),
        }))(LoggingWithRouter);